import Latex from 'react-latex-next';
import { useSelector } from 'react-redux';
import { RootState } from '../../store';

const Ayudantias = () => {
  
  const { ayudantias, isLoading } = useSelector((state: RootState) => state.ayudantia);

  if (isLoading) {
    return (
      <div className="d-flex justify-content-center">
        <div className="spinner-border text-success" role="status">
            <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    )
  }

  return (
    <>
      {
        ayudantias.map((item, index) => {
          const { id, enunciado } = item;
          return (
            <div className='card mb-4' key={id}>
              <div className="card-header">
                  Ejercicio {index+1}
              </div>
              <div className="card-body">
                  <Latex>{enunciado}</Latex>
              </div>
            </div>
          )
        })
      }
    </>
  )
}

export default Ayudantias;